/* eslint-disable @typescript-eslint/default-param-last */
import { DEVTOOLS_ADD_EXTENSION, DEVTOOLS_ADD_LOG, DEVTOOLS_CLEAR_LOGS, DEVTOOLS_SET_PRESERVE_LOGS } from './actions';

const initialState = {
  preserveLogs: false,
  logs: [],
  extensions: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case DEVTOOLS_SET_PRESERVE_LOGS:
      return {
        ...state,
        preserveLogs: action.payload,
      };

    case DEVTOOLS_ADD_LOG:
      return {
        ...state,
        logs: [
          {
            key: Date.now(),
            value: action.payload,
          },
          ...state.logs,
        ],
      };

    case DEVTOOLS_CLEAR_LOGS:
      return {
        ...state,
        logs: [],
      };

    case DEVTOOLS_ADD_EXTENSION:
      return {
        ...state,
        extensions: [...state.extensions, action.payload],
      };

    default:
      return state;
  }
};

export default reducer;
